import { render, staticRenderFns } from "./GameSlider.vue?vue&type=template&id=51ec0f98&scoped=true&"
import script from "./GameSlider.vue?vue&type=script&lang=js&"
export * from "./GameSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ec0f98",
  null
  
)

export default component.exports